import { DesignSubmittalStatus } from 'shared'
import {
  DesignSubmittal,
  useDesignSubmittalLogContext,
} from '../../../../../DesignSubmittalLogContext'
import { useAuthContext } from 'context/AuthContext'
import { Button, Tooltip } from 'antd'

export const Status: React.VFC<DesignSubmittal> = (record) => {
  const { user } = useAuthContext()
  const {
    advancementModal: { toggle },
    permissions: { canRoute, canDisposition },
  } = useDesignSubmittalLogContext()
  const { status, dsToDSDisciplines, deleted } = record
  const canAdvance = (
    status: DesignSubmittalStatus,
    dsToDSDisciplines: DesignSubmittal['dsToDSDisciplines']
  ): boolean => {
    if (!user) {
      return false
    }

    if (status === DesignSubmittalStatus.RouterReview)
      return (
        (canRoute &&
          (dsToDSDisciplines
            .flatMap(({ discipline: { users } }) => users.map(({ id }) => id))
            .includes(user.id) ||
            !dsToDSDisciplines.length)) ||
        user.developer === true
      )
    else if (status === DesignSubmittalStatus.DisciplineAction)
      return (
        canDisposition &&
        !!dsToDSDisciplines.length &&
        dsToDSDisciplines.every(({ accepted }) => accepted)
      )
    else return false
  }
  return canAdvance(status as DesignSubmittalStatus, dsToDSDisciplines) ? (
    <Button
      type="link"
      style={{ padding: 0 }}
      disabled={deleted}
      onClick={() => toggle(record)}
    >
      {status}
    </Button>
  ) : (
    <Tooltip
      title={
        canDisposition && status === DesignSubmittalStatus.DisciplineAction
          ? `All Disciplines must be accepted to advance to ${DesignSubmittalStatus.ReturnedToDesignBuilder}`
          : undefined
      }
    >
      {status}
    </Tooltip>
  )
}
